module.exports = __webpack_public_path__ + "img/PS6.c66c0192.png";